import React from 'react';
import logoImage from './Static_resources/publicSecurityicon.png';

const Footer = () => {
  // 备案信息
  const icpRecord = '沪ICP备18042633号-3';
  const publicSecurityRecord = '沪公网安备31010402336133号';
  
  // 备案链接
  const icpRecordLink = 'https://beian.miit.gov.cn/';
  const publicSecurityRecordLink = 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402336133';

  const styles = {
    footer: {
      backgroundColor: '#f8f9fa',
      borderTop: '1px solid #e9ecef',
      padding: '14px 0',
      marginTop: 'auto',
      fontSize: '13px',
      color: '#555',
      width: '100%',
      lineHeight: '1.4',
      minHeight: 'auto',
      fontFamily: 'system-ui, -apple-system, sans-serif',
    },
    footerContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '18px',
    },
    footerLink: {
      color: '#555',
      textDecoration: 'none',
      transition: 'all 0.3s ease',
      whiteSpace: 'nowrap',
      fontSize: '13px',
      fontWeight: '400',
    },
    footerLinkHover: {
      color: '#1890ff',
      textDecoration: 'underline',
    },
    recordLink: {
      color: '#555',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      transition: 'all 0.3s ease',
      whiteSpace: 'nowrap',
      fontSize: '13px',
      fontWeight: '400',
    },
    recordIcon: {
      width: '16px',
      height: '16px',
      verticalAlign: 'middle',
      flexShrink: 0,
    },
    separator: {
      color: '#ccc',
      margin: '0 6px',
      fontSize: '12px',
    },
    copyright: {
      color: '#777',
      fontSize: '13px',
      whiteSpace: 'nowrap',
      fontWeight: '400',
    },
  };

  // 处理链接悬停
  const handleLinkHover = (e) => {
    e.target.style.color = styles.footerLinkHover.color;
    e.target.style.textDecoration = styles.footerLinkHover.textDecoration;
  };

  const handleLinkLeave = (e) => {
    e.target.style.color = styles.footerLink.color;
    e.target.style.textDecoration = 'none';
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.footerContent}>
        {/* 版权信息 */}
        <span style={styles.copyright}>
          © {new Date().getFullYear()} 上海爱上公益发展中心 - 数字广播系统(HiRadio.cn)
        </span>
        
        <span style={styles.separator}>|</span>
        
        {/* 用户协议 */}
        <a 
          href="/agreement" 
          style={styles.footerLink}
          onMouseEnter={handleLinkHover}
          onMouseLeave={handleLinkLeave}
        >
          用户协议
        </a>
        
        <span style={styles.separator}>|</span>
        
        {/* 使用手册 */}
        <a 
          href="/manual" 
          style={styles.footerLink}
          onMouseEnter={handleLinkHover}
          onMouseLeave={handleLinkLeave}
        >
          使用手册
        </a>
        
        <span style={styles.separator}>|</span>
        
        {/* ICP备案 */}
        <a 
          href={icpRecordLink} 
          target="_blank" 
          rel="noopener noreferrer"
          style={styles.footerLink}
          onMouseEnter={handleLinkHover}
          onMouseLeave={handleLinkLeave}
        >
          {icpRecord}
        </a>
        
        <span style={styles.separator}>|</span>
        
        {/* 公安备案 - 带图标 */}
        <a 
          href={publicSecurityRecordLink} 
          target="_blank" 
          rel="noreferrer"
          style={styles.recordLink}
          onMouseEnter={handleLinkHover}
          onMouseLeave={handleLinkLeave}
        >
          <img 
            src={logoImage} 
            alt="公安备案" 
            style={styles.recordIcon}
            onError={(e) => {
              // 如果图标加载失败，显示文字替代
              e.target.style.display = 'none';
            }}
          />
          {publicSecurityRecord}
        </a>
      </div>
    </footer>
  );
};

export default Footer;